<ng-container *transloco="let t">
  @let labelPacks = labelPacks$ | async;
  @let labelPack = $safeNavigationMigration(labelPacks?.[0]);
  @if (labelPack) {
    <div class="bg-background-primary-alt sticky top-[100px] z-10 flex flex-wrap items-center gap-2 py-2">
      <p class="flex-1">
        {{ t('{count, plural, one {# mot clé} other {# mots clés}}', { count: labelPack.labels.length }) }}
      </p>
      <pxc-filter-bar class="w-full max-sm:order-last sm:max-w-64" />
      <button size="s" tuiButton type="button" (click)="addLabels(labelPack.id)">
        {{ t('Ajouter') }}
      </button>
    </div>

    <pxc-label-table class="mb-4" [actions]="actions" [labels]="labelPack.labels" />
  } @else {
    <pxc-empty-state [title]="t('Aucun pack de mots clés disponible pour ce département.')" />
  }
</ng-container>
